import { FlexBox } from "components/Common/FlexBox"
import {
  StyledNutritionRemaining,
  StyledNutritionItem,
  NutritionName,
  NutritionValue,
  NutritionGoalValue,
  ProgressTrackBar,
} from "./styled"
import { ProgressBar } from "antd-mobile"
import { getDisplayCalories, roundByDecimalPlace } from "utils"
import { useAppSelector } from "app/hooks"
import { useDiaryAnimationLoading } from "features/home/hooks"
import CountUp from "react-countup"
import { useMemo, useRef } from "react"

const getDisplayPercent = (key: string, dailyProgress?: any) => {
  if (!dailyProgress?.goal) return 0

  const gainedNutrition = dailyProgress.pfc[key]
  const nutritionPerDay = dailyProgress.goal.pfc[key]
  const isOver = gainedNutrition > nutritionPerDay

  let result = 0

  if (isOver) {
    result = 100
  } else {
    result = (gainedNutrition / nutritionPerDay) * 100
  }

  result = result > 0 ? result : 0

  return roundByDecimalPlace(result, 0)
}

const IntakeNutrition = () => {
  const dailyProgress = useAppSelector((state) => state.home.dailyProgress)
  const loading = useAppSelector((state) => state.home.getDailyProgressLoading)
  const getDailyProgressCounter = useAppSelector(
    (state) => state.home.getDailyProgressCounter,
  )
  const localLoading = useDiaryAnimationLoading(getDailyProgressCounter)

  const animationLoading = localLoading || loading

  const remainingFat = dailyProgress?.goal
    ? dailyProgress?.goal.pfc.fat - dailyProgress?.pfc?.fat
    : 0
  const remainingProtein = dailyProgress?.goal
    ? dailyProgress?.goal.pfc.protein - dailyProgress?.pfc?.protein
    : 0
  const remainingCarb = dailyProgress?.goal
    ? dailyProgress?.goal.pfc.carb - dailyProgress?.pfc?.carb
    : 0

  const prevNutrition = useRef<any>([])

  const nutrition = useMemo(() => {
    if (localLoading) {
      return prevNutrition.current
    }

    const nextNutrition = [
      {
        name: "Protein",
        value: roundByDecimalPlace(
          remainingProtein > 0 ? remainingProtein : -remainingProtein,
        ),
        isOver: remainingProtein < 0,
        color: "var(--Accent-2, #F354E4)",
        percent: animationLoading
          ? 0
          : getDisplayPercent("protein", dailyProgress),
        goalValue: getDisplayCalories(dailyProgress?.goal?.pfc.protein),
      },
      {
        name: "Fat",
        value: roundByDecimalPlace(
          remainingFat > 0 ? remainingFat : -remainingFat,
        ),
        isOver: remainingFat < 0,
        color: "var(--Schemes-Secondary, #FFC800)",
        percent: animationLoading ? 0 : getDisplayPercent("fat", dailyProgress),
      },
      {
        name: "Carbs",
        value: roundByDecimalPlace(
          remainingCarb > 0 ? remainingCarb : -remainingCarb,
        ),
        isOver: remainingCarb < 0,
        color: "var(--Accent-1, #8948FA)",
        percent: animationLoading
          ? 0
          : getDisplayPercent("carb", dailyProgress),
      },
    ]

    prevNutrition.current = nextNutrition

    return nextNutrition
  }, [localLoading, dailyProgress])

  return (
    <StyledNutritionRemaining>
      {nutrition.map((item: any) => {
        return (
          <StyledNutritionItem key={item.name}>
            <FlexBox
              $alignItems="flex-end"
              $justify="space-between"
              style={{ height: "17px" }}
            >
              <NutritionName> {item.name}</NutritionName>

              <FlexBox $gap={4} $alignItems="center" style={{ height: "17px" }}>
                <NutritionValue>
                  {" "}
                  <span
                    className={`loading-value ${
                      animationLoading && "loading-value--show"
                    }`}
                  >
                    -
                  </span>
                  <span
                    className={`real-value ${
                      animationLoading && "real-value--hidden"
                    }`}
                  >
                    <CountUp
                      separator={","}
                      style={{ display: "inline-block" }}
                      end={item.value}
                      duration={0.5}
                    ></CountUp>
                  </span>
                </NutritionValue>
                <NutritionGoalValue style={{ marginLeft: -2 }}>
                  g
                </NutritionGoalValue>
                <NutritionGoalValue
                  $width={item.isOver ? "23.61px" : "16.74px"}
                >
                  {item.isOver ? "over" : "left"}
                </NutritionGoalValue>
              </FlexBox>
            </FlexBox>

            <div style={{ position: "relative" }}>
              <ProgressTrackBar />

              <ProgressBar
                rounded={item.percent === 0 ? false : true}
                percent={item.percent}
                style={{
                  "--track-width": "4px",
                  "--fill-color": item.isOver ? "#FB6D6D" : item.color,
                  "--track-color": "transparent",
                  zIndex: 2,
                  position: "relative",
                }}
              />
            </div>
          </StyledNutritionItem>
        )
      })}
    </StyledNutritionRemaining>
  )
}

export default IntakeNutrition
